import { IRootState } from '../../../store'
import { IEKGImportState } from '../store/ekgImport.types'

export const getEKGImportSelector = (state: IRootState): IEKGImportState => state.ekgImport
